import { render, staticRenderFns } from "./PaddingProperty.vue?vue&type=template&id=0bb6996b&"
import script from "./PaddingProperty.vue?vue&type=script&lang=js&"
export * from "./PaddingProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports